import createReducer from '../utils/createReducer';

const INITIAL_STATE = null;

export default createReducer('consultantBookingError', INITIAL_STATE, {
  logConsultantBookingError: (state, error) => error,
});
